import { API } from "@/services"

export const USERS_ENDPOINTS = {
  findMe(params={}){
    return API.Axios.humanify.v1.request({
      url: `admin/users/me`,
      method: 'GET',
      params,
    })
  },
}